/**
 * Persona navigation — distinguish agent handoffs from manual nav-rail clicks.
 *
 * Manual nav-rail clicks restore each persona's desk session (or create one on
 * first visit). Contextual routes set preserveConversation to carry the
 * active thread across personas.
 */

export const PRESERVE_CONVERSATION_KEY = 'crucible_preserve_conversation'

export interface WorkspaceChangeInput {
  prevWorkspaceId: string
  nextWorkspaceId: string
  prevSessionId: string
  nextSessionId: string
  preserveConversation: boolean
}

export function shouldResetConversationOnWorkspaceChange(
  input: WorkspaceChangeInput,
): boolean {
  if (input.prevWorkspaceId === input.nextWorkspaceId) return false
  if (input.preserveConversation) return false
  if (input.prevSessionId !== input.nextSessionId) return false
  return true
}

export function markPreserveConversation(): void {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(PRESERVE_CONVERSATION_KEY, '1')
}

export function consumePreserveConversation(): boolean {
  if (typeof sessionStorage === 'undefined') return false
  const preserved = sessionStorage.getItem(PRESERVE_CONVERSATION_KEY) === '1'
  sessionStorage.removeItem(PRESERVE_CONVERSATION_KEY)
  return preserved
}
